import { DISABLED_ACCOUNT_ERROR_CODE, markAccountDisabled } from '../shared/utils/disabledAccountSignal'

export default function callSecureAPI(url, requestType, token, body, options = {}) {
    let requestOb = {
        method: requestType,
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-type': 'application/json',
            'X-CSRF-Token': getCookie('XSRF-TOKEN'),
        },
        withCredentials: true, // Important: This sends cookies with the request
    }

    if (body) {
        requestOb.body = JSON.stringify(body)
    }

    requestOb = { ...requestOb, ...options }

    return fetch(url, requestOb)
        .then((res) => res.json())
        .then((body) => {
            // Only place every response passes through, so it's where a disabled account is noticed.
            if (body?.code === DISABLED_ACCOUNT_ERROR_CODE) {
                markAccountDisabled()
            }

            return body
        })
}

function getCookie(name) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(';').shift()
}
